'use client';
import styled, { css } from 'styled-components';
import { BodyTextMediumA } from '@/shared/ui/typography2';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import { MOBILE_VIEWPORT_QUERY } from '@/shared/hooks/useIsMobile';

const SIDE_INSET = brandIsPh ? 12 : 18;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 36px;
  justify-content: center;
  gap: 14px;

  @media (max-width: 768px) {
    margin-top: 24px;

    ${brandIsPh &&
    css`
      margin-top: 12px;
    `}
  }
`;
export const Title = styled.div`
  display: flex;
  margin: 0;

  @media ${MOBILE_VIEWPORT_QUERY} {
    margin: 0 ${SIDE_INSET}px;
  }
`;
export const Tab = styled.div`
  display: none;
  align-items: flex-start;
  gap: 8px;
  overflow-x: scroll;

  @media ${MOBILE_VIEWPORT_QUERY} {
    display: flex;
  }
`;
export const TabButton = styled.button<{ $isActive?: boolean }>`
  display: flex;
  height: 32px;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;

  border-radius: 8px;
  background: #27262b;

  ${({ $isActive }) =>
    $isActive &&
    `
    background: #4b444c;
  `}

  white-space: nowrap;

  &:first-child {
    margin-left: ${SIDE_INSET}px;
  }

  &:last-child {
    margin-right: ${SIDE_INSET}px;
  }
`;
export const TabHeader = styled(BodyTextMediumA)`
  display: flex;
  height: 32px;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;

  white-space: nowrap;

  @media ${MOBILE_VIEWPORT_QUERY} {
    display: none;
  }
`;
export const ListOfWinList = styled.div`
  display: flex;
  gap: 24px;
  margin: 0;

  @media ${MOBILE_VIEWPORT_QUERY} {
    width: 100%;
    overflow-x: scroll;
    gap: 0;
    scroll-snap-type: x mandatory;
    scroll-behavior: auto;
  }
`;
export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;
  margin: 0;

  @media ${MOBILE_VIEWPORT_QUERY} {
    width: 100%;
    flex: 1 0 100%;
    scroll-snap-align: start;
  }
`;
export const WinList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  text-align: left;

  @media ${MOBILE_VIEWPORT_QUERY} {
    margin: 0 ${SIDE_INSET}px;
  }
`;
